import { useState } from 'react'
import { MenuItem } from '@szhsin/react-menu'
import { SignInAppleDialog } from '../SignInAppleDialog'
import { useNotification } from '../../../providers/NotificationProvider'
import {
  useAppleCalDAVSignout,
  useAppleCalendars,
} from '../../../hooks/AppleCalDAV'
import { errorIcon } from '../../../components/Notification'
import { useCalendarAuth } from '../../../contexts/CalendarAuth/CalendarAuthContext'
import { UnifiedAccountItem } from './UnifiedAccountItem'
import { useLocalStorage } from 'usehooks-ts'

export function AppleCalendarSection() {
  const [showSignInAppleDialog, setShowSignInAppleDialog] =
    useState<boolean>(false)
  const { data: appleData } = useAppleCalendars()
  const appleCalendars = appleData?.calendars || []
  const appleAccount = appleData?.account
  const hasAppleCalendars = appleCalendars.length > 0
  const signout = useAppleCalDAVSignout()
  const { showNotification } = useNotification()
  const { setAppleAuthLoading } = useCalendarAuth()
  const [isExpanded, setIsExpanded] = useLocalStorage('appleAccountExpanded', false)

  function handleAppleSignout() {
    signout.mutate(undefined, {
      onSuccess: () => {
        showNotification({
          title: 'Apple Calendar',
          message: 'Successfully signed out from Apple Calendars',
        })
      },
      onError: (registerError) => {
        showNotification({
          title: 'Apple Calendar',
          message: registerError.response?.data.error ?? 'An error occurred',
          icon: errorIcon,
        })
      },
    })
  }

  if (!hasAppleCalendars) {
    return (
      <>
        <MenuItem
          onClick={() => setShowSignInAppleDialog(true)}
          className='group transition-colors duration-150'
        >
          <div className='flex items-center gap-2'>
            <div className='flex h-5 w-5 items-center justify-center rounded bg-black text-white transition-transform duration-150 group-hover:scale-110 dark:bg-white dark:text-black'>
              <i className='fab fa-apple text-xs' aria-hidden='true' />
            </div>
            <span className='text-sm'>Sign in with Apple</span>
          </div>
        </MenuItem>
        <SignInAppleDialog
          open={showSignInAppleDialog}
          setOpen={setShowSignInAppleDialog}
          onLoadingChange={setAppleAuthLoading}
        />
      </>
    )
  }

  return (
    <>
      <MenuItem disabled className='relative'>
        <span className='text-xs font-bold text-gray-400 dark:text-gray-400'>
          APPLE
        </span>
      </MenuItem>
      <UnifiedAccountItem
        accountName={
          appleAccount?.email
            ? appleAccount.email
                .split('@')[0]
                .split('.')
                .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
                .join(' ')
            : 'Apple Calendar'
        }
        accountEmail={appleAccount?.email}
        calendars={appleCalendars}
        onRemove={handleAppleSignout}
        provider='apple'
        isExpanded={isExpanded}
        onToggleExpansion={() => setIsExpanded(!isExpanded)}
      />
      <SignInAppleDialog
        open={showSignInAppleDialog}
        setOpen={setShowSignInAppleDialog}
        onLoadingChange={setAppleAuthLoading}
      />
    </>
  )
}
